import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PolicyRuleDetailSkeleton = () => (
  <Styles.Container>
    <Styles.SectionContainer>
      <Skeleton variant="text" width={120} height={24} />
      <Skeleton variant="rounded" width="100%" height={56} />
      <Skeleton variant="rounded" width="100%" height={100} />
      <Styles.DateRow>
        <Skeleton variant="rounded" width="100%" height={56} />
        <Skeleton variant="rounded" width="100%" height={56} />
      </Styles.DateRow>
    </Styles.SectionContainer>
  </Styles.Container>
)

export default PolicyRuleDetailSkeleton
